<template>
  <div class="flex flex-col justify-start items-center">
    <h2 class="flex justify-start items-center space-x-2 w-full mb-4 mr-4">
      <span v-if="!resetPassword">Login</span>
      <span v-if="resetPassword">Reset Password</span>
    </h2>

    <!-- SIGN IN INPUT -->
    <div v-if="!resetPassword && !emailSubmitResponse" class="w-full relative">
      <div class="w-full">
        <p>Email</p>
        <input
          id="email-address"
          v-model="emailInput"
          :class="'placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600'"
          class="flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary text-black focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 mb-4"
          name="email"
          type="email"
          autocomplete="off"
          placeholder="example@example.com"
          @keyup="checkValidation"
          @change="checkValidation"
        />
      </div>
      <div class="w-full">
        <!-- TO DO - hook up password instead of email validation -->
        <p>Password</p>
        <div
          class="flex lg:flex-nowrap flex-wrap space-x-2 items-center justify-center"
        >
          <input
            id="password"
            v-model="passwordInput"
            :class="'placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600'"
            class="flex-grow px-4 outline-none focus:outline-none bg-transparent h-12 font-primary text-black focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 w-full lg:w-3/4"
            name="password"
            type="password"
            autocomplete="off"
            placeholder="enter your password"
            @keyup="checkValidation"
            @change="checkValidation"
          />
          <!-- SIGN IN BUTTON -->
          <div v-if="!emailSubmitResponse" class="relative text-left">
            <button
              :disabled="!canSubmit"
              :class="[!canSubmit ? 'opacity-25' : '', thinking ? '' : '']"
              class="relative rounded-lg py-4 px-8 text-white font-primary text-center ease-in-out duration-300 h-12 bg-primary mt-8 lg:mt-0 lg:w-auto w-60"
              @click="submitLogin"
            >
              <div class="flex justify-center items-center w-full h-full">
                <div
                  class="absolute inset-0 w-full flex justify-center items-center z-20"
                >
                  <lottie v-if="thinking" :options="loadingAnimationOptions" />
                </div>
                <div
                  :class="[thinking ? 'invisible' : '']"
                  class="w-full flex items-center justify-center"
                >
                  Submit
                </div>
              </div>
            </button>
          </div>
          <!-- /SIGN IN BUTTON -->
        </div>
      </div>
    </div>

    <!-- RESET INPUT -->
    <div v-if="resetPassword" class="w-full relative">
      <div class="w-full">
        <p>Email</p>
      </div>
      <div class="w-full">
        <!-- TO DO - hook up password instead of email validation -->
        <div
          class="flex flex-wrap lg:flex-nowrap lg:space-x-2 justify-center items-center"
        >
          <input
            id="email-address"
            v-model="emailResetInput"
            :class="'placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600'"
            class="flex-grow px-4 m-0 outline-none focus:outline-none bg-transparent w-full h-12 font-primary text-black focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300"
            name="email"
            type="email"
            autocomplete="off"
            placeholder="example@example.com"
            @keyup="checkValidation"
            @change="checkValidation"
          />
          <!-- RESET BUTTON -->
          <div class="relative text-left w-full lg:w-auto">
            <button
              :disabled="!canSubmit"
              :class="[!canSubmit ? 'opacity-25' : '', thinking ? '' : '']"
              class="relative rounded-lg py-4 px-8 text-white font-primary text-center ease-in-out duration-300 h-12 bg-primary ml-auto mt-6 lg:mt-0 w-full lg:w-auto"
              @click="submitReset"
            >
              <div class="flex justify-center items-center w-full h-full">
                <div
                  class="absolute inset-0 w-full flex justify-center items-center z-20"
                >
                  <lottie v-if="thinking" :options="loadingAnimationOptions" />
                </div>
                <div
                  :class="[thinking ? 'invisible' : '']"
                  class="w-full flex items-center justify-center"
                >
                  Submit
                </div>
              </div>
            </button>
          </div>
          <!-- /RESET BUTTON -->
        </div>
      </div>
    </div>

    <div
      v-if="!resetPassword"
      class="border-t border-truegray-300 p-4 pl-0 w-full mt-6"
    >
      <h6 class="text-truegray-500" @click="resetPassword = !resetPassword">
        Forgot your password?
        <a class="text-sm font-semibold underline">click here</a>
      </h6>
    </div>

    <div
      v-if="resetPassword"
      class="border-t border-truegray-300 p-4 pl-0 w-full mt-6"
    >
      <h6 class="text-truegray-500" @click="toggleResetPassword">
        <a class="text-sm font-semibold underline">Cancel</a>
      </h6>
    </div>
  </div>
</template>

<script>
import { shared } from '../../js/mixins/shared.js'
import { EventBus } from '../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../shared/components/loading.json'

export default {
  mixins: [shared],

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      canSubmit: false,
      thinking: false,
      rememberMe: 0,
      emailInput: '',
      passwordInput: '',
      emailResetInput: '',
      userAlreadyRegistered: false,
      signingin: false,
      emailSubmitResponse: false,
      emailSubmitResponseSuccess: false,
      resetPassword: false,
    }
  },

  watch: {
    emailInput: {
      handler: function (val) {
        // Remove all white space from inputs...
        val = val.replace(/\s+/g, '') // or you can use your own preferred way to remove leading spaces
        this.$set(this, 'emailInput', val)
      },

      deep: true,
    },

    passwordInput: {
      handler: function (val) {
        // Remove all white space from inputs...
        val = val.replace(/\s+/g, '') // or you can use your own preferred way to remove leading spaces
        this.$set(this, 'passwordInput', val)
      },

      deep: true,
    },

    emailResetInput: {
      handler: function (val) {
        // Remove all white space from inputs...
        val = val.replace(/\s+/g, '') // or you can use your own preferred way to remove leading spaces
        this.$set(this, 'emailResetInput', val)
      },

      deep: true,
    },
  },

  mounted() {
    // When the theme changes dynamically we also need to changed stored theme data variables...
    EventBus.$on('validateSignInEmail', (email) => {
      this.$set(this, 'emailInput', email)
      this.validateSignInEmail()
    })

    // When the theme changes dynamically we also need to changed stored theme data variables...
    EventBus.$on('modalAlertClose', () => {
      this.$set(this, 'emailSubmitResponse', false)
      this.$set(this, 'emailInput', '')
    })
  },

  methods: {
    noemptychars: function (event) {
      if (event.keyCode === 32) {
        event.preventDefault()
      }
    },

    // Saving animations
    // handleLoadingAnimation: function (active) {
    //   // this.loadingAnimate = active;
    // },

    hideLoginModal() {
      this.$set(this, 'emailSubmitResponse', false)
      this.$set(this, 'emailSubmitResponseSuccess', false)

      this.$set(this, 'emailInput', '')
      // EventBus.$emit('toggleLoginModal');
    },

    checkValidation() {
      let canSubmit = true
      // Enable / dissable sign in button depending on the validity of the email they have provided
      if (!this.resetPassword) {
        if (
          !this.validateEmail(this.emailInput) ||
          this.passwordInput.length < 3
        ) {
          canSubmit = false
        }
      } else {
        if (!this.validateEmail(this.emailResetInput)) {
          canSubmit = false
        }
      }

      this.$set(this, 'canSubmit', canSubmit)
    },

    submitLogin() {
      this.thinking = true
      // Disable the sign in button so that we do not interupt or clog up the call...
      this.$set(this, 'signingin', true)
      // Submit the access auth and kill the preloader...
      let rememberMe = this.rememberMe // Default the expiry token to be in a years time!
      // axios.post('/api/send-access-token',{email: this.emailInput, rememberMe : rememberMe})
      axios
        .post('/api/login', {
          email: this.emailInput,
          password: this.passwordInput,
          rememberMe: rememberMe,
        })
        .then((response) => {
          this.$set(this, 'emailSubmitResponse', true)
          this.$set(this, 'signingin', false)
          this.$set(this, 'thinking', false)
          this.$set(this, 'canSubmit', true)

          let returned = response.data

          if (returned.success) {
            this.$set(this, 'emailSubmitResponseSuccess', true)

            // Token is good. Set the oAuth Bearer and confirm user has been logged in!
            auth.signIn(returned.access_token, returned.user, returned.expires)
            const authenticated = auth.isAuthenticated()
            if (authenticated) {
              // this.$router.push({ path: '/'});
              EventBus.$emit('triggerAlertResponse', {
                status: 'success',
                message: 'Successfully logged in!',
              })
            } else {
              EventBus.$emit('triggerAlertResponse', {
                status: 'error',
                message: 'Something went wrong!',
              })
            }
          } else {
            this.$set(this, 'emailSubmitResponseSuccess', false)

            EventBus.$emit('triggerAlertResponse', {
              status: 'error',
              message: 'Something went wrong!',
            })
          }

          EventBus.$emit('showModal', false)
        })
    },

    submitReset() {
      // Disable the sign in button so that we do not interupt or clog up the call...
      this.$set(this, 'signingin', true)
      this.$set(this, 'thinking', true)
      // Submit the access auth and kill the preloader...
      axios
        .post('/api/reset-password', { email: this.emailResetInput })
        .then((response) => {
          this.$set(this, 'emailSubmitResponse', true)
          this.$set(this, 'signingin', false)
          this.$set(this, 'thinking', false)
          this.$set(this, 'canSubmit', true)

          let returned = response.data

          if (returned.success) {
            this.$set(this, 'emailSubmitResponseSuccess', true)
            EventBus.$emit('triggerAlertResponse', {
              status: 'success',
              message: 'Please check your email inbox',
            })
            EventBus.$emit('showModal', false)
          } else {
            EventBus.$emit('triggerAlertResponse', {
              status: 'error',
              message: 'Something went wrong!',
            })
          }

          // EventBus.$emit('toggleLoginModal');
        })
    },

    toggleResetPassword() {
      // if (this.emailSubmitResponse && !this.emailSubmitResponseSuccess) {
      // EventBus.$emit('toggleLoginModal');
      // }
      let resetStatus = !this.resetPassword
      this.$set(this, 'resetPassword', resetStatus)
    },
  },
}
</script>
